var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 5.5249H4.35039C4.05039 5.5249 3.77539 5.7749 3.77539 6.0999C3.77539 6.4249 4.02539 6.6749 4.35039 6.6749H7.65039C7.95039 6.6749 8.22539 6.4249 8.22539 6.0999C8.22539 5.7749 7.95039 5.5249 7.65039 5.5249Z",
    fill: "#111928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3746 0.449951H1.62461C0.774609 0.449951 0.0996094 1.12495 0.0996094 1.97495V9.99995C0.0996094 10.375 0.24961 10.725 0.52461 10.975L5.02461 15.225C5.27461 15.475 5.59961 15.6 5.94961 15.6H10.3496C11.1996 15.6 11.8746 14.925 11.8746 14.075V1.97495C11.8996 1.12495 11.1996 0.449951 10.3746 0.449951ZM2.04961 10.85H4.97461C5.09961 10.85 5.19961 10.95 5.19961 11.05V13.8L2.04961 10.85ZM10.7746 14.025C10.7746 14.25 10.5996 14.425 10.3746 14.425H6.32461V11.05C6.32461 10.325 5.72461 9.72495 4.97461 9.72495H1.22461V1.97495C1.22461 1.74995 1.39961 1.57495 1.62461 1.57495H10.3496C10.5746 1.57495 10.7496 1.74995 10.7496 1.97495V14.025H10.7746Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg44);
export default __webpack_public_path__ + "static/media/svg44.f985130f62585abbd0c8036e7c022d34.svg";
export { ForwardRef as ReactComponent };